<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import invoiceStore from "./store.js";

export default {
  name: "invoice",
  mixins: [RegisterStoreModule],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    ...mapGetters("invoice", ["InvoiceDetails"]),
    showLegacyHeader() {
      return this.$route.name !== "invoice-list";
    },
  },
  methods: {
    ...mapActions("invoice", ["ResetInvoice"]),
    newInvoice() {
      if (this.InvoiceDetails.length !== 0) {
        this.$swal({
          title: "Are you sure?",
          text: "There is an running invoice you want to clear it",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.ResetInvoice();
            if (this.CustomerId) {
              this.$router.push({
                path: `/invoice/create?CustomerId=${this.CustomerId}`,
              });
            } else {
              this.$router.push({ path: `/invoice/create` });
            }
          }
        });
      } else {
        if (this.CustomerId) {
          this.$router.push({
            path: `/invoice/create?CustomerId=${this.CustomerId}`,
          });
        } else {
          this.$router.push({ path: `/invoice/create` });
        }
      }
    },
  },
  created() {
    this.registerStoreModule("invoice", invoiceStore);
  },
};
</script>
